import type DocumentTypePresetView from '@UI/Store/OrganizationWorkflows/Views/DocumentTypePresetView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The global preset catalogue: no tenant, no scope — every account reads the very same list.
 */
class WorkflowCatalogView {
	readonly list: readonly DocumentTypePresetView[];

	constructor(list: readonly DocumentTypePresetView[]) {
		this.list = list;

		Object.freeze(this);
	}

	/**
	 * The preset of a document type (matched on `DocumentType.key`), falling back to the generic
	 * preset (`documentTypeKey` null); null when the catalogue has neither.
	 */
	findForDocumentType(documentTypeKey: string | null): DocumentTypePresetView | null {
		return (
			this.list.find(
				(preset) => documentTypeKey !== null && preset.documentTypeKey === documentTypeKey,
			) ??
			this.list.find((preset) => preset.documentTypeKey === null) ??
			null
		);
	}
}

export default WorkflowCatalogView;
